import { render, staticRenderFns } from "./AALevel.vue?vue&type=template&id=024637a2&"
import script from "./AALevel.vue?vue&type=script&lang=js&"
export * from "./AALevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports